import PropTypes from "prop-types";
import { HiExclamationTriangle, HiArrowRight, HiXMark } from "react-icons/hi2";
import CustomModal from "../CustomModal/CustomModal";
import CustomButton from "../CustomButton/CustomButton";

export default function CustomLeaveConfirmationModal({
  opened,
  onStay,
  onLeave,
  title = "Don't leave yet",
  message,
  leaveLabel = "Leave anyway",
  stayLabel = "Stay and finish",
  leaveButtonColor,
  LeaveIcon = HiArrowRight,
  StayIcon = HiXMark,
  children,
}) {
  return (
    <CustomModal
      opened={opened}
      onClose={onStay}
      withCloseButton={false}
      centered
      radius="lg"
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
      styles={{ body: { padding: "24px" } }}
    >
      <div className="flex flex-col items-center text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 mb-4">
          <HiExclamationTriangle size={28} className="text-amber-600" />
        </div>

        <h2 className="text-base font-semibold text-gray-900 mb-2">{title}</h2>

        <p className="text-sm text-gray-500 leading-relaxed">{message}</p>

        {children}
      </div>

      <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <CustomButton
          variant="default"
          color={leaveButtonColor}
          leftSection={<LeaveIcon size={15} />}
          onClick={onLeave}
          className="w-full sm:w-auto"
        >
          {leaveLabel}
        </CustomButton>
        <CustomButton
          color="dark"
          leftSection={<StayIcon size={15} />}
          onClick={onStay}
          className="w-full sm:w-auto"
        >
          {stayLabel}
        </CustomButton>
      </div>
    </CustomModal>
  );
}

CustomLeaveConfirmationModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  onStay: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.node.isRequired,
  leaveLabel: PropTypes.string,
  stayLabel: PropTypes.string,
  leaveButtonColor: PropTypes.string,
  LeaveIcon: PropTypes.elementType,
  StayIcon: PropTypes.elementType,
  children: PropTypes.node,
};
